export default __webpack_public_path__ + "island5.518b2a890e7f51e8b5179877e8597768.png";